import React from 'react'
import { Link } from 'react-router-dom'

const SubmissionsLink = ({ session_summary, base_url }) => (
  <Link to={`${base_url}/${session_summary.id}`}>
    {session_summary.child.first_name}&#x27;s Submissions
  </Link>
)

export default SubmissionsLink



// WEBPACK FOOTER //
// ./src/payments/details/views/submissions-link.jsx